// Help util to read values from DOM
export function getMetaTagName(metaName: string) {
  if (!document) return null;

  const element = document.head?.querySelector(`[name=${metaName}]`) as HTMLMetaElement;

  if (!element) {
    return null;
  }

  return element.content;
}
